"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Avatar = _interopRequireDefault(require("../Avatar"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var dashSize = 116;

var ProgressSvg = _styledComponents["default"].svg.withConfig({
  displayName: "AvatarProgress__ProgressSvg",
  componentId: "sc-70hpde-0"
})(["stroke-width:2.25px;fill:transparent;stroke-linecap:round;stroke-linejoin:round;width:100%;height:100%;"]);

var Background = _styledComponents["default"].path.withConfig({
  displayName: "AvatarProgress__Background",
  componentId: "sc-70hpde-1"
})(function (_ref) {
  var theme = _ref.theme,
      whiteBackground = _ref.whiteBackground;
  return (0, _styledComponents.css)(["fill:", ";"], whiteBackground ? theme.color.paper : 'transparent');
});

var Stroke = _styledComponents["default"].path.withConfig({
  displayName: "AvatarProgress__Stroke",
  componentId: "sc-70hpde-2"
})(function (props) {
  return (0, _styledComponents.css)(["stroke:", ";stroke-dasharray:", " ", ";transition:all 0.3s ease;"], props.value > 0 ? props.theme.color.action : 'transparent', props.value, dashSize);
});

var HiddenProgress = _styledComponents["default"].progress.withConfig({
  displayName: "AvatarProgress__HiddenProgress",
  componentId: "sc-70hpde-3"
})(["visibility:hidden;width:0;height:0;"]);

var StyledAvatar = (0, _styledComponents["default"])(_Avatar["default"]).withConfig({
  displayName: "AvatarProgress__StyledAvatar",
  componentId: "sc-70hpde-4"
})([".bpcl-avatar-prism-border{fill:", ";}"], function (props) {
  return props.theme.color.hover;
});

var getDashValue = function getDashValue(percent) {
  return percent / 100 * dashSize;
};
/**
 *
 * #### Blue Prism styled `AvatarProgress` component

This component wraps the `Avatar` component and adds a visual progress bar around its border. A percentage value is used to reflect percentage completed.

See https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Live_Regions for more information
 */


var AvatarProgress = function AvatarProgress(_ref2) {
  var _ref2$image = _ref2.image,
      image = _ref2$image === void 0 ? null : _ref2$image,
      _ref2$percent = _ref2.percent,
      percent = _ref2$percent === void 0 ? 0 : _ref2$percent,
      _ref2$whiteBackground = _ref2.whiteBackground,
      whiteBackground = _ref2$whiteBackground === void 0 ? false : _ref2$whiteBackground,
      rest = _objectWithoutProperties(_ref2, ["image", "percent", "whiteBackground"]);

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(ProgressSvg, {
    width: "100%",
    height: "100%",
    viewBox: "0 0 48 48",
    role: "img"
  }, /*#__PURE__*/_react["default"].createElement(Background, {
    d: "M24,5.4 45.5,30.06 24,43.13 2.46,30.06Z",
    whiteBackground: whiteBackground
  }), /*#__PURE__*/_react["default"].createElement(StyledAvatar, {
    image: image
  }), /*#__PURE__*/_react["default"].createElement(Stroke, {
    d: "M24,5.4 45.5,30.06 24,43.13 2.46,30.06Z",
    value: getDashValue(percent)
  })), /*#__PURE__*/_react["default"].createElement(HiddenProgress, {
    "aria-live": rest['aria-live'],
    value: percent,
    max: "100"
  }));
};

var _default = AvatarProgress;
exports["default"] = _default;